<template>
  <b-row class="">
    <b-col cols="12">
      <b-form-group
        :label="$lang.name_company"
        label-for="name_company"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.name_company"
          :rules="$v.name_company.$params"
        />
        <b-form-input
          type="text"
          :autocomplete="$lang.name_company"
          v-model="$v.name_company.$model"
          :state="$v.name_company.$dirty ? !$v.name_company.$error : null"
        >
        </b-form-input>
        <b-form-invalid-feedback id="description-feedback">
          {{ $lang.error_required | replace($lang.name_company) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="6">
      <b-form-group
        :label="$lang.city_name"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.city_name"
          :rules="$v.location_selected.$params"
        />
        <selectAsync
          :options="location_options"
          v-model="$v.location_selected.$model"
          label="caption"
          :asyncFind="getLocation"
          :isValid="
            $v.location_selected.$dirty ? !$v.location_selected.$error : null
          "
          :loading="location_loading"
          :placeholder="$lang.search_city"
        />
        <b-form-invalid-feedback
          :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.city_name)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12" md="6">
      <b-form-group
        :label="$lang.zone_number"
        label-for="zone_number"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.zone_number"
          :rules="$v.zone_number.$params"
        />
        <b-form-input
          type="text"
          :autocomplete="$lang.zone_number"
          v-model="$v.zone_number.$model"
          :state="$v.zone_number.$dirty ? !$v.zone_number.$error : null"
        >
        </b-form-input>
        <b-form-invalid-feedback id="description-feedback">
          {{ $lang.error_required | replace($lang.zone_number) }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="$v.zone_number.$error"
          id="name-feedback"
        >
          {{
            $lang.error_Value
              .replace("{0}", $lang.Personal_biography)
              .replace("{1}", "1")
              .replace("{2}", "25")
          }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="6">
      <b-form-group
        :label="$lang.from_year"
        label-for="from_year"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.from_year"
          :rules="$v.from_year.$params"
        />
        <date-picker
          v-model="$v.from_year.$model"
          :max="new Date() | moment('jYYYY')"
          :state="$v.from_year.$dirty ? !$v.from_year.$error : null"
          type="year"
          inputReq="true"
          auto-submit
          clearable
          simple
          :class="
            $v.from_year.$dirty
              ? $v.from_year.$error
                ? 'invalid-date'
                : 'valid-date'
              : null
          "
        >
        </date-picker>
        <b-form-invalid-feedback
          :style="{ display: $v.from_year.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.from_year)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>
    <b-col cols="12" md="6">
      <b-form-group
        :label="$lang.to_year"
        label-for="to_year"
        :label-cols="$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.to_year"
          :rules="$v.to_year.$params"
        />
        <date-picker
          v-model="$v.to_year.$model"
          :state="$v.to_year.$dirty ? !$v.to_year.$error : null"
          type="year"
          inputReq="true"
          auto-submit
          clearable
          simple
          :min="$v.from_year.$model"
          :max="new Date() | moment('jYYYY')"
          :class="
            $v.to_year.$dirty
              ? $v.to_year.$error
                ? 'invalid-date'
                : 'valid-date'
              : null
          "
        >
        </date-picker>
        <b-form-invalid-feedback
          :style="{ display: $v.to_year.$error ? 'block' : 'none' }"
          id="gender_id-feedback"
        >
          {{
            $lang.error_required | replace($lang.to_year)
          }}</b-form-invalid-feedback
        >
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-form-group
        :label="$lang.description_cooperation"
        label-for="description_cooperation"
        :label-cols="12"
      >
        <requiredComponent
          slot="label"
          :label="$lang.description_cooperation"
          :rules="$v.description_cooperation.$params"
        />
        <b-form-textarea
          id="description_cooperation"
          :state="
            $v.description_cooperation.$dirty
              ? !$v.description_cooperation.$error
              : null
          "
          v-model="$v.description_cooperation.$model"
          type="text"
          :autocomplete="$lang.description_cooperation"
          :rows="$config.form.textareaRows"
        ></b-form-textarea>
        <b-form-invalid-feedback id="description_cooperation-feedback">
          {{ $lang.error_required | replace($lang.description_cooperation) }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col xs="12" md="12">
      <div class="form-group form-btn">
        <b-button
          variant="success"
          v-if="isAdmin(parentPermissions)"
          @click="submit"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button class="ml-2" variant="danger" @click="cancel">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { isAdmin } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  validations: {
    name_company: {
      required,
    },
    to_year: {
      required,
    },
    from_year: {
      required,
    },
    zone_number: {},
    location_selected: {
      required,
    },
    description_cooperation: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      places: [],
      location_loading: false,
      location_options: [],
      name_company: null,
      to_year: null,
      from_year: null,
      zone_number: null,
      location_selected: null,
      description_cooperation: null,
    };
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    pathOr,
    isAdmin,
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        name: this.name_company,
        from_year: this.from_year,
        description: this.description_cooperation,
        to_year: this.to_year,
        location_id: pathOr(null, ["id"], this.location_selected),
        zone_number: this.zone_number,
      };
      this.$emit("submit", payload);
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.location_options = [];
      }

      try {
        this.location_loading = true;
        const url = `${this.$config.api_url}${this.$config.resources.location}?city=${query}`;
        const response = await this.$httpService.get(url);
        this.location_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.location_loading = false;
      }
    },
    fetchData() {
      if (Object.keys(this.item).length) {
        this.name_company = pathOr(null, ["name"], this.item);
        this.from_year = pathOr(null, ["from_year"], this.item);
        this.to_year = pathOr(null, ["to_year"], this.item);
        this.description_cooperation = pathOr(null, ["description"], this.item);
        this.zone_number = this.pathOr(
          null,
          ["address", "zone_number"],
          this.item
        );
        this.location_selected = {
          id: pathOr(null, ["address", "location", "id"], this.item),
          caption: pathOr(
            null,
            ["address", "location", "full_path"],
            this.item
          ),
        };
      }
    },
  },
};
</script>
